export default __webpack_public_path__ + "static/finportcase1-67bc61cd2860ee3ebfd20b20187fc8c5.png";